export const MILLION = 1_000_000;
export const SEARCH_MIN_LENGTH = 3;
export const DEBOUNCE_DELAY = 300;
export const MARKETING_DEBOUNCE_DELAY = 600;
export const DOUBLE_CLICK_DELAY = 300;
export const MARKETING_PAGE_SIZE = 50;
export const MARKETING_MAX_ITEMS = 10000;
export const OG_IMAGE_WIDTH = 1200;
export const OG_IMAGE_QUALITY = 85;
export const MY_ACCOUNT_TABS = [1, 2, 3];
